export function resolveStandaloneUrl(relativeHref) {
  const base = process.env.VUE_APP_BASE_URL || window.location.href
  const path = relativeHref.startsWith('./') ? relativeHref.slice(2) : relativeHref
  return new URL(path, base).href
}

export function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).catch(fallbackCopy)
  }
  return fallbackCopy(text)
}

function fallbackCopy(text) {
  const el = document.createElement('textarea')
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
  return Promise.resolve()
}
